<template>
  <div class="dropdown-wrapper no-print">
    <AppButton icon="more_horiz" v-tooltip="{text: 'Mere', pos: 'right'}" @click="toggle()" :style="dropped ? 'pointer-events:none' : ''" />
    <transition name="dropdown">
      <div v-if="dropped" class="dropdown-options">      
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'AppDropdown',
  setup() {
    const dropped = ref(false)

    function collapse() {
      document.body.removeEventListener('click', collapse, true)
      dropped.value = false
    }

    function toggle() {
      if (dropped.value) {
        collapse()
      } else {
        dropped.value = true
        document.body.addEventListener('click', collapse, true)
      }
    }

    return { dropped, toggle }
  }
})
</script>

<style lang="scss">
.dropdown-enter-active, .dropdown-leave-active {
  transition: opacity .1s, transform .1s;
  opacity: 1;
  transform: scale(1);
}
.dropdown-enter-from, .dropdown-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0.9);
}

.dropdown-wrapper {
  position: relative;

  .dropdown-options {
    position: absolute;
    box-shadow: var(--card-shadow);
    background: var(--color-card-elevated);
    z-index: 1000000;
    right: 0;
    //width: 16rem;
    padding: .5rem;
    border-radius: 1rem;
    transform-origin: top right;
    overflow: hidden;

    &.dropped {
      opacity: 1;
      pointer-events: all;
      transform: scale(1);
    }

    button {
      display: flex;
      width: 100%;
      box-shadow: none;
    }
  }
}
</style>